require('../../modules/es6.reflect.enumerate');
module.exports = require('../../modules/$.core').Reflect.enumerate;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/fn/reflect/enumerate.js
 ** module id = 22
 ** module chunks = 0
 **/